module.exports = __webpack_public_path__ + "static/10 Happier-2fad6f2d27f98e479ed9403f227c02e0.jpg";